import React, { useEffect, useState } from "react";
import { nav, profile } from "../mock";
import { ShieldCheck, Menu, X } from "lucide-react";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("about");
  const [dateStr, setDateStr] = useState("");
  const [timeStr, setTimeStr] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const tick = () => {
      const d = new Date();
      const fullStr = d.toLocaleString("sv-SE", { timeZone: "Asia/Kolkata" });
      const parts = fullStr.split(" ");
      setDateStr(parts[0]);
      setTimeStr(parts[1] + " IST");
    };
    tick();
    const i = setInterval(tick, 1000);
    return () => clearInterval(i);
  }, []);

  useEffect(() => {
    const sections = nav.map((n) => document.getElementById(n.id)).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px" }
    );
    sections.forEach((s) => obs.observe(s));
    return () => obs.disconnect();
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled || open ? "bg-[#07090d]/95 backdrop-blur-md border-b border-[#1c2533]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-16">
          <a href="#about" className="flex items-center gap-2.5 group hover-glitch">
            <div className="relative">
              <ShieldCheck className="w-6 h-6 text-cyan-400" strokeWidth={1.5} />
              <span className="absolute -top-1 -right-1 w-1.5 h-1.5 rounded-full bg-cyan-400 pulse-dot" />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-mono text-[11px] tracking-[0.2em] text-cyan-400">AL//SOC</span>
              <span className="font-mono text-[9px] tracking-[0.15em] text-slate-500">L2-ANALYST</span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((n, i) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                className={`relative px-3 py-2 font-mono text-[11px] tracking-[0.18em] transition-colors ${
                  active === n.id ? "text-cyan-400" : "text-slate-400 hover:text-slate-100"
                }`}
              >
                <span className="text-cyan-500/50 mr-1.5">{String(i + 1).padStart(2, "0")}</span>
                {n.label}
                {active === n.id && (
                  <span className="absolute -bottom-0.5 left-3 right-3 h-px bg-cyan-400" />
                )}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <div className="font-mono text-[9px] tracking-[0.15em] text-slate-500 flex items-center gap-2">
              <span className="text-cyan-400 pulse-dot">●</span>
              <div className="flex flex-col text-left leading-none gap-0.5">
                <span className="text-slate-400">{dateStr}</span>
                <span className="text-cyan-400/80">{timeStr}</span>
              </div>
            </div>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-slate-300 p-1"
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div className="lg:hidden pb-4 border-t border-[#1c2533] pt-3">
            <div className="grid grid-cols-2 gap-1 mb-4">
              {nav.map((n, i) => (
                <a
                  key={n.id}
                  href={`#${n.id}`}
                  onClick={() => setOpen(false)}
                  className="px-3 py-2 font-mono text-[11px] tracking-[0.18em] text-slate-300 hover:text-cyan-400"
                >
                  <span className="text-cyan-500/50 mr-1.5">{String(i + 1).padStart(2, "0")}</span>
                  {n.label}
                </a>
              ))}
            </div>
            <div className="border-t border-[#1c2533]/50 pt-3 px-3 flex items-center gap-2 font-mono text-[10px] tracking-[0.15em] text-slate-500">
              <span className="text-cyan-400 pulse-dot">●</span>
              <span>{dateStr}</span>
              <span className="text-cyan-400/80">{timeStr}</span>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;
